var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('adagent'),_vm._v(" "),_c('adenterprise')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }